import NavbarTopListItem from "@/layout/Navbar/Top/Sub/NavbarTopListItem";
import { mainFasiliasNavMenus } from "@/layout/Navbar/Side/Sub/SubFasilitas";

const ListItemFasilitas = () => {
  return (
    <NavbarTopListItem menus={mainFasiliasNavMenus} anchor={'listItemFasilitas'}/>
  );
};

export default ListItemFasilitas;
